import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import Product from '../pages/product';

export function Products() {
  return (
    <Routes>
      <Route path='/' element={<Index child={<Product />}/>} />
    </Routes>
  );
}
